import { ChangeDetectionStrategy, Component, computed, input, signal } from '@angular/core';

import { TranslatePipe } from '@core/i18n-legacy';
import {
  ButtonComponent,
  DividerComponent,
  HeadingComponent,
  IconComponent,
} from '@core/user-interface-legacy';

@Component({
  selector: 'text-presenter',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div class="file-presenter">
      <rt-heading varaint="heading small" margin-bottom-small-xx>
        {{ config().heading }}
      </rt-heading>
      @if (config().value) {
        <div class="rt-card file">
          <div class="preview">
            @if (isPreviewLoadError()) {
              <div class="extension">
                {{ extension() }}
              </div>
            } @else {
              <img
                class="image"
                [src]="config().value"
                alt="File preview"
                (error)="isPreviewLoadError.set(true)"
              />
            }
          </div>
          <rt-divider />
          <div class="footer">
            <a rt-button variant="primary" [href]="config().value" download>
              <rt-icon name="file-download" />
              {{ 'tlc.dynamic_form.present.download' | translate }}
            </a>
          </div>
        </div>
      } @else {
        <p text-darkest>-</p>
      }
    </div>
  `,
  styleUrl: './file-presenter.component.less',
  imports: [HeadingComponent, DividerComponent, ButtonComponent, TranslatePipe, IconComponent],
})
export class FilePresenterComponent {
  public config = input.required<{
    heading: string;
    value: string | null;
  }>();

  protected isPreviewLoadError = signal(false);

  protected extension = computed((): string => {
    const { value } = this.config();
    if (!value) return '';

    const parts = new URL(value).pathname.split('/');
    const last = parts[parts.length - 1];
    const extension = last.split('.').pop();
    if (!extension) return '';

    return extension;
  });
}
